/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const requestedDeliveryDate = {
  requestedDeliveryDate: {
    datePickerLabel: 'Solicitar fecha de entrega',
    readOnlyTextLabel: 'Fecha de entrega solicitada',
    successMessage: 'Fecha de entrega actualizada con éxito.',
    errorMessage: 'Algo salió mal. No se puede actualizar la fecha solicitada.',
  },
};
